const PatientsList = ({filterPatients,action,searchTerm,setSearchTerm,actionLabel,heading}) => {
  const newHeading = heading || "Patients List";
  return (
      <div className="doc-patient-container">
          <p>{newHeading}</p>
          <div className="doc-patient-search-cont">
            {/* <p>Search By First name</p> */}
            <input
              type="text"
              placeholder="Search by first name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="doc-patient-search-input"
            />
          </div>
          <div className="doc-patient-grid-container">
            <div className="doc-patient-grid doc-grid-heading">
              <p>First Name</p>
              <p>Last Name</p>
              <p>Gender</p>
              <p>Date Of Birth</p>
              <p>Action</p>
            </div>
            {filterPatients?.length > 0 ? (
              filterPatients
                .filter((patient) =>
                  patient.first_name
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
                )
                .map((patient) => (
                  <div
                    key={patient?.patient_id}
                    className="doc-patient-grid doc-grid-item"
                  >
                    <p translate="no">{patient?.first_name}</p>
                    <p translate="no">{patient?.last_name}</p>
                    <p>{patient?.gender}</p>
                    <p>{patient.date_of_birth.split(",")[1].slice(0, 12)}</p>
                    <button onClick={() => action(patient)}>
                      {actionLabel}
                    </button>
                  </div>
                ))
            ) : (
              <p>No existing patients found</p>
            )}
          </div>
        </div>
  )
}
export default PatientsList